import styled from "styled-components";

export const VersionPageContainer = styled.div`
  display: grid;
  grid-template-columns: 0.2fr 1fr;
  width: 100%;
  height: calc(100% - 196px);
`;

export const VersionPageLeftContainer = styled.div`
  height: 100%;  
  overflow: hidden;
`;

export const VersionPageRightContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props)=>props.theme.colors.white};
  height: 100%;
`;